  const config = {
    apiBaseUrl: 'https://dashboard.physicianslifeline.com'
  };

  export default config;
